import { CustomerPage } from "@/components/analyze-customer/customer-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/customer/$kundennummer")({
  component: CustomerPage,
});
